import { Container} from "react-bootstrap";

export default function NotAuthorized() {
  return (
    <Container className="notFoundCenterPositioned">
      <h1>Oops! You are not authorized to see this page.</h1>
      <p>Please contact your IDPH administator</p>
    </Container>
  );
}